module.exports = __webpack_public_path__ + "assets/2400e38158408e421703ca18dfea6dc0.mp4";